import ifp6552 from "../../assets/products/viewboard/ifp52/IFP_6552_Education.glb";
import ifp6552crop from "../../assets/products/viewboard/ifp52/IFP_6552_crop.glb";
import ifp6552class from "../../assets/products/viewboard/ifp52/IFP_6552_class.glb";
import ifp6552board from "../../assets/products/viewboard/ifp52/IFP_6552_board.glb";
import ifp7552 from "../../assets/products/viewboard/ifp52/IFP_7552_Education.glb";
import ifp7552crop from "../../assets/products/viewboard/ifp52/IFP_7552_crop.glb";
import ifp7552class from "../../assets/products/viewboard/ifp52/IFP_7552_class.glb";
import ifp7552board from "../../assets/products/viewboard/ifp52/IFP_7552_board.glb";
import ifp8652 from "../../assets/products/viewboard/ifp52/IFP_8652_Education.glb";
import ifp8652crop from "../../assets/products/viewboard/ifp52/IFP_8652_crop.glb";
import ifp8652class from "../../assets/products/viewboard/ifp52/IFP_8652_class.glb";
import ifp8652board from "../../assets/products/viewboard/ifp52/IFP_8652_board.glb";
import ifp65522f from "../../assets/products/viewboard/IFP52-2F/IFP6552-2F_Education.glb";
import ifp65522fcrop from "../../assets/products/viewboard/IFP52-2F/IFP6552-2F_Corporate.glb";
import ifp65522fclass from "../../assets/products/viewboard/IFP52-2F/IFP6552-2F_Classroom.glb";
import ifp65522fboard from "../../assets/products/viewboard/IFP52-2F/IFP6552-2F_Boardroom.glb";
import ifp75522f from "../../assets/products/viewboard/IFP52-2F/IFP7552-2F_Education.glb";
import ifp75522fcrop from "../../assets/products/viewboard/IFP52-2F/IFP7552-2F_Corporate.glb";
import ifp75522fclass from "../../assets/products/viewboard/IFP52-2F/IFP7552-2F_Classroom.glb";
import ifp75522fboard from "../../assets/products/viewboard/IFP52-2F/IFP7552-2F_Boardroom.glb";
import ifp86522f from "../../assets/products/viewboard/IFP52-2F/IFP8652-2F_Education.glb";
import ifp86522fcrop from "../../assets/products/viewboard/IFP52-2F/IFP8652-2F_Corporate.glb";
import ifp86522fclass from "../../assets/products/viewboard/IFP52-2F/IFP8652-2F_Classroom.glb";
import ifp86522fboard from "../../assets/products/viewboard/IFP52-2F/IFP8652-2F_Boardroom.glb";
import ifp6532 from "../../assets/products/viewboard/ifp32/IFP_6532.glb";
import ifp6532crop from "../../assets/products/viewboard/ifp32/IFP_6532_crop.glb";
import ifp6532class from "../../assets/products/viewboard/ifp32/IFP_6532_class.glb";
import ifp6532board from "../../assets/products/viewboard/ifp32/IFP_6532_board.glb";
import ifp7532 from "../../assets/products/viewboard/ifp32/IFP_7532.glb";
import ifp7532crop from "../../assets/products/viewboard/ifp32/IFP_7532_crop.glb";
import ifp7532class from "../../assets/products/viewboard/ifp32/IFP_7532_class.glb";
import ifp7532board from "../../assets/products/viewboard/ifp32/IFP_7532_board.glb";
import ifp8632 from "../../assets/products/viewboard/ifp32/IFP_8632.glb";
import ifp8632crop from "../../assets/products/viewboard/ifp32/IFP_8632_crop.glb";
import ifp8632class from "../../assets/products/viewboard/ifp32/IFP_8632_class.glb";
import ifp8632board from "../../assets/products/viewboard/ifp32/IFP_8632_board.glb";
import ifp6562 from "../../assets/products/viewboard/ifp62/IFP_6562.glb";
import ifp6562crop from "../../assets/products/viewboard/ifp62/IFP_6562_crop.glb";
import ifp6562class from "../../assets/products/viewboard/ifp62/IFP_6562_class.glb";
import ifp6562board from "../../assets/products/viewboard/ifp62/IFP_6562_board.glb";
import ifp7562 from "../../assets/products/viewboard/ifp62/IFP_7562.glb";
import ifp7562crop from "../../assets/products/viewboard/ifp62/IFP_7562_crop.glb";
import ifp7562class from "../../assets/products/viewboard/ifp62/IFP_7562_class.glb";
import ifp7562board from "../../assets/products/viewboard/ifp62/IFP_7562_board.glb";
import ifp8662 from "../../assets/products/viewboard/ifp62/IFP_8662.glb";
import ifp8662crop from "../../assets/products/viewboard/ifp62/IFP_8662_crop.glb";
import ifp8662class from "../../assets/products/viewboard/ifp62/IFP_8662_class.glb";
import ifp8662board from "../../assets/products/viewboard/ifp62/IFP_8662_board.glb";
import ifp6550 from "../../assets/products/viewboard/ifp50/IFP_6550_Education.glb";
import ifp6550crop from "../../assets/products/viewboard/ifp50/IFP_6550_crop.glb";
import ifp6550class from "../../assets/products/viewboard/ifp50/IFP_6550_class.glb";
import ifp6550board from "../../assets/products/viewboard/ifp50/IFP_6550_board.glb";
import ifp7550 from "../../assets/products/viewboard/ifp50/IFP_7550_Education.glb";
import ifp7550crop from "../../assets/products/viewboard/ifp50/IFP_7550_crop.glb";
import ifp7550class from "../../assets/products/viewboard/ifp50/IFP_7550_class.glb";
import ifp7550board from "../../assets/products/viewboard/ifp50/IFP_7550_board.glb";
import ifp8650 from "../../assets/products/viewboard/ifp50/IFP_8650_Education.glb";
import ifp8650crop from "../../assets/products/viewboard/ifp50/IFP_8650_crop.glb";
import ifp8650class from "../../assets/products/viewboard/ifp50/IFP_8650_class.glb";
import ifp8650board from "../../assets/products/viewboard/ifp50/IFP_8650_board.glb";
import ifp5551 from "../../assets/products/viewboard/IFP51/IFP5551.glb";
import ifp6551 from "../../assets/products/viewboard/IFP51/IFP6551.glb";
import ifp7551 from "../../assets/products/viewboard/IFP51/IFP7551.glb";
import ifp8651 from "../../assets/products/viewboard/IFP51/IFP8651.glb";
import ifp9851 from "../../assets/products/viewboard/IFP51/IFP9851.glb";
import ifpultrawide from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Education.glb";
import ifpultrawideclass from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Classroom.glb";
import ifpultrawidecrop from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Corporate.glb";
import ifpultrawideboard from "../../assets/products/viewboard/IFPUltrawide/IFPUltrawide_Boardroom.glb";
import ifp110 from "../../assets/products/viewboard/IFP110/IFP110_Education.glb";
import ifp110class from "../../assets/products/viewboard/IFP110/IFP110_Classroom.glb";
import ifp110crop from "../../assets/products/viewboard/IFP110/IFP110_Corporate.glb";
import ifp110board from "../../assets/products/viewboard/IFP110/IFP110_Boardroom.glb";
import ifp9850 from "../../assets/products/viewboard/ifp9850/ifp9850_education.glb";
import ifp9850class from "../../assets/products/viewboard/ifp9850/ifp9850_classroom.glb";
import ifp9850crop from "../../assets/products/viewboard/ifp9850/ifp9850_corporate.glb";
import ifp9850board from "../../assets/products/viewboard/ifp9850/ifp9850_boardroom.glb";
import ifp6533 from "../../assets/products/viewboard/IFP33/IFP6533_Education.glb";
import ifp6533board from "../../assets/products/viewboard/IFP33/IFP6533_Boardroom.glb";
import ifp6533class from "../../assets/products/viewboard/IFP33/IFP6533_Classroom.glb";
import ifp6533crop from "../../assets/products/viewboard/IFP33/IFP6533_Corporate.glb";
import ifp7533 from "../../assets/products/viewboard/IFP33/IFP7533_Education.glb"
import ifp7533board from "../../assets/products/viewboard/IFP33/IFP7533_Boardroom.glb"
import ifp7533class from "../../assets/products/viewboard/IFP33/IFP7533_Classroom.glb"
import ifp7533crop from "../../assets/products/viewboard/IFP33/IFP7533_Corporate.glb"
import ifp8633 from "../../assets/products/viewboard/IFP33/IFP8633_Education.glb"
import ifp8633board from "../../assets/products/viewboard/IFP33/IFP8633_Boardroom.glb"
import ifp8633class from "../../assets/products/viewboard/IFP33/IFP8633_Classroom.glb"
import ifp8633crop from "../../assets/products/viewboard/IFP33/IFP8633_Corporate.glb"
import ifp55g1 from "../../assets/products/viewboard/IFPGenesis/IFP55Genesis_Education.glb"
import ifp55g1board from "../../assets/products/viewboard/IFPGenesis/IFP55Genesis_Boardroom.glb"
import ifp55g1class from "../../assets/products/viewboard/IFPGenesis/IFP55Genesis_Classroom.glb"
import ifp55g1crop from "../../assets/products/viewboard/IFPGenesis/IFP55Genesis_Corporate.glb"
import ifp65g1 from "../../assets/products/viewboard/IFPGenesis/IFP65Genesis_Education.glb"
import ifp65g1board from "../../assets/products/viewboard/IFPGenesis/IFP65Genesis_Boardroom.glb"
import ifp65g1class from "../../assets/products/viewboard/IFPGenesis/IFP65Genesis_Classroom.glb"
import ifp65g1crop from "../../assets/products/viewboard/IFPGenesis/IFP65Genesis_Corporate.glb"
import ifp75g1 from "../../assets/products/viewboard/IFPGenesis/IFP75Genesis_Education.glb"
import ifp75g1board from "../../assets/products/viewboard/IFPGenesis/IFP75Genesis_Boardroom.glb"
import ifp75g1class from "../../assets/products/viewboard/IFPGenesis/IFP75Genesis_Classroom.glb"
import ifp75g1crop from "../../assets/products/viewboard/IFPGenesis/IFP75Genesis_Corporate.glb"
import ifp86g1 from "../../assets/products/viewboard/IFPGenesis/IFP86Genesis_Education.glb"
import ifp86g1board from "../../assets/products/viewboard/IFPGenesis/IFP86Genesis_Boardroom.glb"
import ifp86g1class from "../../assets/products/viewboard/IFPGenesis/IFP86Genesis_Classroom.glb"
import ifp86g1crop from "../../assets/products/viewboard/IFPGenesis/IFP86Genesis_Corporate.glb"


// free standing
import lds138Campus from "../../assets/products/allInOne/lds/LDS138-151_Campus.glb";
import lds138Crop from "../../assets/products/allInOne/lds/LDS138-151_Corporate.glb";



//cde
import cde4330board from "../../assets/products/commercial_display/CDE30/CDE4330_Boardroom.glb";
import cde4330campus from "../../assets/products/commercial_display/CDE30/CDE4330_Campus.glb";
import cde4330campusV from "../../assets/products/commercial_display/CDE30/CDE4330_Campus_Vertical.glb"
import cde4330crop from "../../assets/products/commercial_display/CDE30/CDE4330_Corporate.glb";
import cde4330cropV from "../../assets/products/commercial_display/CDE30/CDE4330_Corporate_Vertical.glb";
import cde4330retail from "../../assets/products/commercial_display/CDE30/CDE4330_Retail.glb";
import cde4330retailV from "../../assets/products/commercial_display/CDE30/CDE4330_Retail_Vertical.glb";
// These three horizontal 55" assets are present in the repo with a 5330 prefix.
import cde5530board from "../../assets/products/commercial_display/CDE30/CDE5330_Boardroom.glb";
import cde5530campus from "../../assets/products/commercial_display/CDE30/CDE5330_Campus.glb";
import cde5530crop from "../../assets/products/commercial_display/CDE30/CDE5330_Corporate.glb";
import cde5530campusV from "../../assets/products/commercial_display/CDE30/CDE5530_Campus_Vertical.glb";
import cde5530cropV from "../../assets/products/commercial_display/CDE30/CDE5530_Corporate_Vertical.glb";
import cde5530retail from "../../assets/products/commercial_display/CDE30/CDE5530_Retail.glb";
import cde5530retailV from "../../assets/products/commercial_display/CDE30/CDE5530_Retail_Vertical.glb";
import cde6530board from "../../assets/products/commercial_display/CDE30/CDE6530_Boardroom.glb";
import cde6530campus from "../../assets/products/commercial_display/CDE30/CDE6530_Campus.glb";
import cde6530campusV from "../../assets/products/commercial_display/CDE30/CDE6530_Campus_Vertical.glb";
import cde6530crop from "../../assets/products/commercial_display/CDE30/CDE6530_Corporate.glb";
import cde6530cropV from "../../assets/products/commercial_display/CDE30/CDE6530_Corporate_Vertical.glb";
import cde6530retail from "../../assets/products/commercial_display/CDE30/CDE6530_Retail.glb";
import cde6530retailV from "../../assets/products/commercial_display/CDE30/CDE6530_Retail_Vertical.glb";
import cde7530board from "../../assets/products/commercial_display/CDE30/CDE7530_Boardroom.glb";
import cde7530campus from "../../assets/products/commercial_display/CDE30/CDE7530_Campus.glb";
import cde7530campusV from "../../assets/products/commercial_display/CDE30/CDE7530_Campus_Vertical.glb";
import cde7530crop from "../../assets/products/commercial_display/CDE30/CDE7530_Corporate.glb";
import cde7530cropV from "../../assets/products/commercial_display/CDE30/CDE7530_Corporate_Vertical.glb";
import cde7530retail from "../../assets/products/commercial_display/CDE30/CDE7530_Retail.glb";
import cde7530retailV from "../../assets/products/commercial_display/CDE30/CDE7530_Retail_Vertical.glb";
import cde8630board from "../../assets/products/commercial_display/CDE30/CDE8630_Boardroom.glb";
import cde8630campus from "../../assets/products/commercial_display/CDE30/CDE8630_Campus.glb";
import cde8630campusV from "../../assets/products/commercial_display/CDE30/CDE8630_Campus_Vertical.glb";
import cde8630crop from "../../assets/products/commercial_display/CDE30/CDE8630_Corporate.glb";
import cde8630cropV from "../../assets/products/commercial_display/CDE30/CDE8630_Corporate_Vertical.glb";
import cde8630retail from "../../assets/products/commercial_display/CDE30/CDE8630_Retail.glb";
import cde8630retailV from "../../assets/products/commercial_display/CDE30/CDE8630_Retail_Vertical.glb";
import cde9830board from "../../assets/products/commercial_display/CDE30/CDE9830_Boardroom.glb";
import cde9830campus from "../../assets/products/commercial_display/CDE30/CDE9830_Campus.glb";
import cde9830campusV from "../../assets/products/commercial_display/CDE30/CDE9830_Campus_Vertical.glb";
import cde9830crop from "../../assets/products/commercial_display/CDE30/CDE9830_Corporate.glb";
import cde9830cropV from "../../assets/products/commercial_display/CDE30/CDE9830_Corporate_Vertical.glb";
import cde9830retail from "../../assets/products/commercial_display/CDE30/CDE9830_Retail.glb";
import cde9830retailV from "../../assets/products/commercial_display/CDE30/CDE9830_Retail_Vertical.glb";
import cde92uwboard from "../../assets/products/commercial_display/CDEUW/CDE92UW_Boardroom.glb";
import cde92uwcampus from "../../assets/products/commercial_display/CDEUW/CDE92UW_Campus.glb";
import cde92uwcampusV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Campus_Vertical.glb"
import cde92uwcrop from "../../assets/products/commercial_display/CDEUW/CDE92UW_Corporate.glb";
import cde92uwcropV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Corporate_Vertical.glb"
import cde92uwretail from "../../assets/products/commercial_display/CDEUW/CDE92UW_Retail.glb";
import cde92uwretailV from "../../assets/products/commercial_display/CDEUW/CDE92UW_Retail_Vertical.glb"
import cde43142cBoard from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Horizontal_Boardroom.glb";
import cde43142cCampus from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Horizontal_Campus.glb";
import cde43142cCampusV from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Vertical_Campus.glb";
import cde43142cCrop from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Horizontal_Corporate.glb";
import cde43142cCropV from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Vertical_Corporate.glb";
import cde43142cRetail from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Horizontal_Retail.glb";
import cde43142cRetailV from "../../assets/products/commercial_display/CDE14/CDE4314-2C_Vertical_Retail.glb";
import cde50142cBoard from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Horizontal_Boardroom.glb";
import cde50142cCampus from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Horizontal_Campus.glb";
import cde50142cCampusV from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Vertical_Campus.glb";
import cde50142cCrop from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Horizontal_Corporate.glb";
import cde50142cCropV from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Vertical_Corporate.glb";
import cde50142cRetail from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Horizontal_Retail.glb";
import cde50142cRetailV from "../../assets/products/commercial_display/CDE14/CDE5014-2C_Vertical_Retail.glb";
import cde55142cBoard from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Horizontal_Boardroom.glb";
import cde55142cCampus from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Horizontal_Campus.glb";
import cde55142cCampusV from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Vertical_Campus.glb";
import cde55142cCrop from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Horizontal_Corporate.glb";
import cde55142cCropV from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Vertical_Corporate.glb";
import cde55142cRetail from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Horizontal_Retail.glb";
import cde55142cRetailV from "../../assets/products/commercial_display/CDE14/CDE5514-2C_Vertical_Retail.glb";
import cde65142cBoard from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Horizontal_Boardroom.glb";
import cde65142cCampus from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Horizontal_Campus.glb";
import cde65142cCampusV from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Vertical_Campus.glb";
import cde65142cCrop from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Horizontal_Corporate.glb";
import cde65142cCropV from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Vertical_Corporate.glb";
import cde65142cRetail from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Horizontal_Retail.glb";
import cde65142cRetailV from "../../assets/products/commercial_display/CDE14/CDE6514-2C_Vertical_Retail.glb";
import cde75142cBoard from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Horizontal_Boardroom.glb";
import cde75142cCampus from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Horizontal_Campus.glb";
import cde75142cCampusV from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Vertical_Campus.glb";
import cde75142cCrop from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Horizontal_Corporate.glb";
import cde75142cCropV from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Vertical_Corporate.glb";
import cde75142cRetail from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Horizontal_Retail.glb";
import cde75142cRetailV from "../../assets/products/commercial_display/CDE14/CDE7514-2C_Vertical_Retail.glb";
import cde86142cBoard from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Horizontal_Boardroom.glb";
import cde86142cCampus from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Horizontal_Campus.glb";
import cde86142cCampusV from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Vertical_Campus.glb";
import cde86142cCrop from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Horizontal_Corporate.glb";
import cde86142cCropV from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Vertical_Corporate.glb";
import cde86142cRetail from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Horizontal_Retail.glb";
import cde86142cRetailV from "../../assets/products/commercial_display/CDE14/CDE8614-2C_Vertical_Retail.glb";
import cde4331Board from "../../assets/products/commercial_display/CDE31/CDE4331_horizontal_Boardroom.glb";
import cde4331Campus from "../../assets/products/commercial_display/CDE31/CDE4331_horizontal_Campus.glb";
import cde4331CampusV from "../../assets/products/commercial_display/CDE31/CDE4331_vertical_Campus.glb";
import cde4331Crop from "../../assets/products/commercial_display/CDE31/CDE4331_horizontal_Corporate.glb";
import cde4331CropV from "../../assets/products/commercial_display/CDE31/CDE4331_vertical_Corporate.glb";
import cde4331Retail from "../../assets/products/commercial_display/CDE31/CDE4331_horizontal_Retail.glb";
import cde4331RetailV from "../../assets/products/commercial_display/CDE31/CDE4331_vertical_Retail.glb";
import cde5531Board from "../../assets/products/commercial_display/CDE31/CDE5531_horizontal_Boardroom.glb";
import cde5531Campus from "../../assets/products/commercial_display/CDE31/CDE5531_horizontal_Campus.glb";
import cde5531CampusV from "../../assets/products/commercial_display/CDE31/CDE5531_vertical_Campus.glb";
import cde5531Crop from "../../assets/products/commercial_display/CDE31/CDE5531_horizontal_Corporate.glb";
import cde5531CropV from "../../assets/products/commercial_display/CDE31/CDE5531_vertical_Corporate.glb";
import cde5531Retail from "../../assets/products/commercial_display/CDE31/CDE5531_horizontal_Retail.glb";
import cde5531RetailV from "../../assets/products/commercial_display/CDE31/CDE5531_vertical_Retail.glb";
import cde6531Board from "../../assets/products/commercial_display/CDE31/CDE6531_horizontal_Boardroom.glb";
import cde6531Campus from "../../assets/products/commercial_display/CDE31/CDE6531_horizontal_Campus.glb";
import cde6531CampusV from "../../assets/products/commercial_display/CDE31/CDE6531_vertical_Campus.glb";
import cde6531Crop from "../../assets/products/commercial_display/CDE31/CDE6531_horizontal_Corporate.glb";
import cde6531CropV from "../../assets/products/commercial_display/CDE31/CDE6531_vertical_Corporate.glb";
import cde6531H from "../../assets/products/commercial_display/CDE31/CDE6531_horizontal.glb";
import cde6531RetailV from "../../assets/products/commercial_display/CDE31/CDE6531_vertical_retail.glb";
import cde7531Board from "../../assets/products/commercial_display/CDE31/CDE7531_horizontal_Boardroom.glb";
import cde7531Campus from "../../assets/products/commercial_display/CDE31/CDE7531_horizontal_Campus.glb";
import cde7531CampusV from "../../assets/products/commercial_display/CDE31/CDE7531_vertical_Campus.glb";
import cde7531Crop from "../../assets/products/commercial_display/CDE31/CDE7531_horizontal_Corporate.glb";
import cde7531CropV from "../../assets/products/commercial_display/CDE31/CDE7531_vertical_Corporate.glb";
import cde7531Retail from "../../assets/products/commercial_display/CDE31/CDE7531_horizontal_Retail.glb";
import cde7531RetailV from "../../assets/products/commercial_display/CDE31/CDE7531_vertical_retail.glb";
import cde8631Board from "../../assets/products/commercial_display/CDE31/CDE8631_horizontal_Boardroom.glb";
import cde8631Campus from "../../assets/products/commercial_display/CDE31/CDE8631_horizontal_Campus.glb";
import cde8631CampusV from "../../assets/products/commercial_display/CDE31/CDE8631_vertical_Campus.glb";
import cde8631Crop from "../../assets/products/commercial_display/CDE31/CDE8631_horizontal_Corporate.glb";
import cde8631CropV from "../../assets/products/commercial_display/CDE31/CDE8631_vertical_Corporate.glb";
import cde8631Retail from "../../assets/products/commercial_display/CDE31/CDE8631_horizontal_Retail.glb";
import cde8631RetailV from "../../assets/products/commercial_display/CDE31/CDE8631_vertical_retail.glb";
import cde9831Board from "../../assets/products/commercial_display/CDE31/CDE9831_horizontal_Boardroom.glb";
import cde9831CampusV from "../../assets/products/commercial_display/CDE31/CDE9831_vertical_Campus.glb";
import cde9831Crop from "../../assets/products/commercial_display/CDE31/CDE9831_horizontal_Corporate.glb";
import cde9831CropV from "../../assets/products/commercial_display/CDE31/CDE9831_vertical_Corporate.glb";
import cde9831H from "../../assets/products/commercial_display/CDE31/CDE9831_horizontal.glb";
import cde9831Retail from "../../assets/products/commercial_display/CDE31/CDE9831_horizontal_Retail.glb";
import cde9831RetailV from "../../assets/products/commercial_display/CDE31/CDE9831_vertical_retail.glb";
import cde43g3Board from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Horizontal_Boardroom.glb";
import cde43g3Campus from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Horizontal_Campus.glb";
import cde43g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Vertical_Campus.glb";
import cde43g3Crop from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Horizontal_Corporate.glb";
import cde43g3CropV from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Vertical_Corporate.glb";
import cde43g3Retail from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Horizontal_Retail.glb";
import cde43g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE43G3-1C_Vertical_Retail.glb";
import cde55g3Board from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Horizontal_Boardroom.glb";
import cde55g3Campus from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Horizontal_Campus.glb";
import cde55g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Vertical_Campus.glb";
import cde55g3Crop from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Horizontal_Corporate.glb";
import cde55g3CropV from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Vertical_Corporate.glb";
import cde55g3Retail from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Horizontal_Retail.glb";
import cde55g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE55G3-1C_Vertical_Retail.glb";
import cde65g3Board from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Horizontal_Boardroom.glb";
import cde65g3Campus from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Horizontal_Campus.glb";
import cde65g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Vertical_Campus.glb";
import cde65g3Crop from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Horizontal_Corporate.glb";
import cde65g3CropV from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Vertical_Corporate.glb";
import cde65g3Retail from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Horizontal_Retail.glb";
import cde65g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE65G3-1C_Vertical_Retail.glb";
import cde75g3Board from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Horizontal_Boardroom.glb";
import cde75g3Campus from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Horizontal_Campus.glb";
import cde75g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Vertical_Campus.glb";
import cde75g3Crop from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Horizontal_Corporate.glb";
import cde75g3CropV from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Vertical_Corporate.glb";
import cde75g3Retail from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Horizontal_Retail.glb";
import cde75g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE75G3-1C_Vertical_Retail.glb";
import cde86g3Board from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Horizontal_Boardroom.glb";
import cde86g3Campus from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Horizontal_Campus.glb";
import cde86g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Vertical_Campus.glb";
import cde86g3Crop from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Horizontal_Corporate.glb";
import cde86g3CropV from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Vertical_Corporate.glb";
import cde86g3Retail from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Horizontal_Retail.glb";
import cde86g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE86G3-1C_Vertical_Retail.glb";
import cde98g3Board from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Horizontal_Boardroom.glb";
import cde98g3Campus from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Horizontal_Campus.glb";
import cde98g3CampusV from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Vertical_Campus.glb";
import cde98g3Crop from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Horizontal_Corporate.glb";
import cde98g3CropV from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Vertical_Corporate.glb";
import cde98g3Retail from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Horizontal_Retail.glb";
import cde98g3RetailV from "../../assets/products/commercial_display/CDEG3/CDE98G3-1C_Vertical_Retail.glb";
import lde108123 from "../../assets/products/allInOne/lde/LDE108-123.glb";
import lde136g152 from "../../assets/products/allInOne/lde/LDE136G-152.glb";
import lde163g182 from "../../assets/products/allInOne/lde/LDE163G-182.glb";

//All in One Display
import ldm135 from "../../assets/products/allInOne/ldm/LDM136-151.glb"
import ldm163 from "../../assets/products/allInOne/ldm/LDM163-182.glb"
import ldm231 from "../../assets/products/allInOne/ldm/LDM231-251.glb"
import ldc027120 from "../../assets/products/allInOne/LDC027/LDC027-120.glb";
import ldc027150 from "../../assets/products/allInOne/LDC027/LDC027-150.glb";
import ldc027180 from "../../assets/products/allInOne/LDC027/LDC027-180.glb";
import ldc027g091c from "../../assets/products/allInOne/LDC027/LDC027G-091C.glb";
import ldc027g121 from "../../assets/products/allInOne/LDC027/LDC027G-121.glb";
import ldc027g151 from "../../assets/products/allInOne/LDC027/LDC027G-151.glb";
import ldc027g181 from "../../assets/products/allInOne/LDC027/LDC027G-181.glb";
import ldc031120 from "../../assets/products/allInOne/LDC031/LDC031-120.glb";
import ldc031150 from "../../assets/products/allInOne/LDC031/LDC031-150.glb";
import ldc031180 from "../../assets/products/allInOne/LDC031/LDC031-180.glb";
import ldc031250 from "../../assets/products/allInOne/LDC031/LDC031-250.glb";
import ldc031g121 from "../../assets/products/allInOne/LDC031/LDC031G-121.glb";
import ldc031g151 from "../../assets/products/allInOne/LDC031/LDC031G-151.glb";
import ldc031g181 from "../../assets/products/allInOne/LDC031/LDC031G-181.glb";
import ldc031g251 from "../../assets/products/allInOne/LDC031/LDC031G-251.glb";
import ldp136071c from "../../assets/products/allInOne/LDP/LDP136-071C.glb";
import ldp163091c from "../../assets/products/allInOne/LDP/LDP163-091C.glb";
import ldp217121c from "../../assets/products/allInOne/LDP/LDP217-121C.glb";

let models = {
    "ifp6552edu": ifp6552,
    "ifp7552edu": ifp7552,
    "ifp8652edu": ifp8652,
    "ifp6552-2fedu": ifp65522f,
    "ifp7552-2fedu": ifp75522f,
    "ifp8652-2fedu": ifp86522f,
    "ifp6550edu": ifp6550,
    "ifp7550edu": ifp7550,
    "ifp8650edu": ifp8650,
    "ifp5551edu": ifp5551,
    "ifp6551edu": ifp6551,
    "ifp7551edu": ifp7551,
    "ifp8651edu": ifp8651,
    "ifp9851edu": ifp9851,
    "ifp6532edu": ifp6532,
    "ifp6533edu": ifp6533,
    "ifp7532edu": ifp7532,
    "ifp7533edu": ifp7533,
    "ifp8632edu": ifp8632,
    "ifp8633edu": ifp8633,
    "ifp6562edu": ifp6562,
    "ifp7562edu": ifp7562,
    "ifp8662edu": ifp8662,
    "ifp55g1edu": ifp55g1,
    "ifp65g1edu": ifp65g1,
    "ifp75g1edu": ifp75g1,
    "ifp86g1edu": ifp86g1,
    "ifp6552crop": ifp6552crop,
    "ifp7552crop": ifp7552crop,
    "ifp8652crop": ifp8652crop,
    "ifp6552-2fcrop": ifp65522fcrop,
    "ifp7552-2fcrop": ifp75522fcrop,
    "ifp8652-2fcrop": ifp86522fcrop,
    "ifp6550crop": ifp6550crop,
    "ifp7550crop": ifp7550crop,
    "ifp8650crop": ifp8650crop,
    "ifp5551crop": ifp5551,
    "ifp6551crop": ifp6551,
    "ifp7551crop": ifp7551,
    "ifp8651crop": ifp8651,
    "ifp9851crop": ifp9851,
    "ifp6532crop": ifp6532crop,
    "ifp6533crop": ifp6533crop,
    "ifp7532crop": ifp7532crop,
    "ifp7533crop": ifp7533crop,
    "ifp8632crop": ifp8632crop,
    "ifp8633crop": ifp8633crop,
    "ifp6562crop": ifp6562crop,
    "ifp7562crop": ifp7562crop,
    "ifp8662crop": ifp8662crop,
    "ifp55g1crop": ifp55g1crop,
    "ifp65g1crop": ifp65g1crop,
    "ifp75g1crop": ifp75g1crop,
    "ifp86g1crop": ifp86g1crop,
    "ifp6552class": ifp6552class,
    "ifp7552class": ifp7552class,
    "ifp8652class": ifp8652class,
    "ifp6552-2fclass": ifp65522fclass,
    "ifp7552-2fclass": ifp75522fclass,
    "ifp8652-2fclass": ifp86522fclass,
    "ifp6550class": ifp6550class,
    "ifp7550class": ifp7550class,
    "ifp8650class": ifp8650class,
    "ifp6532class": ifp6532class,
    "ifp6533class": ifp6533class,
    "ifp7532class": ifp7532class,
    "ifp7533class": ifp7533class,
    "ifp8632class": ifp8632class,
    "ifp8633class": ifp8633class,
    "ifp6562class": ifp6562class,
    "ifp7562class": ifp7562class,
    "ifp8662class": ifp8662class,
    "ifp55g1class": ifp55g1class,
    "ifp65g1class": ifp65g1class,
    "ifp75g1class": ifp75g1class,
    "ifp86g1class": ifp86g1class,
    "ifp6552board": ifp6552board,
    "ifp7552board": ifp7552board,
    "ifp8652board": ifp8652board,
    "ifp6552-2fboard": ifp65522fboard,
    "ifp7552-2fboard": ifp75522fboard,
    "ifp8652-2fboard": ifp86522fboard,
    "ifp6550board": ifp6550board,
    "ifp7550board": ifp7550board,
    "ifp8650board": ifp8650board,
    "ifp6532board": ifp6532board,
    "ifp6533board": ifp6533board,
    "ifp7532board": ifp7532board,
    "ifp7533board": ifp7533board,
    "ifp8632board": ifp8632board,
    "ifp8633board": ifp8633board,
    "ifp6562board": ifp6562board,
    "ifp7562board": ifp7562board,
    "ifp8662board": ifp8662board,
    "ifp55g1board": ifp55g1board,
    "ifp65g1board": ifp65g1board,
    "ifp75g1board": ifp75g1board,
    "ifp86g1board": ifp86g1board,
    "ifp105uwedu": ifpultrawide,
    "ifp105uwclass": ifpultrawideclass,
    "ifp105uwcrop": ifpultrawidecrop,
    "ifp105uwboard": ifpultrawideboard,
    "ifp110edu": ifp110,
    "ifp110class": ifp110class,
    "ifp110crop": ifp110crop,
    "ifp110board": ifp110board,
    "ifp9850-4edu": ifp9850,
    "ifp9850-4class": ifp9850class,
    "ifp9850-4crop": ifp9850crop,
    "ifp9850-4board": ifp9850board,
    "LDS138-151campus": lds138Campus,
    "LDS138-151crop": lds138Crop,
    "LDS138-151": lds138Crop,
    "CDE4330board": cde4330board,
    "CDE4330campus": cde4330campus,
    "CDE4330campusV": cde4330campusV,
    "CDE4330crop": cde4330crop,
    "CDE4330cropV": cde4330cropV,
    "CDE4330retail": cde4330retail,
    "CDE4330retailV": cde4330retailV,
    "CDE5530board": cde5530board,
    "CDE5530campus": cde5530campus,
    "CDE5530campusV": cde5530campusV,
    "CDE5530crop": cde5530crop,
    "CDE5530cropV": cde5530cropV,
    "CDE5530retail": cde5530retail,
    "CDE5530retailV": cde5530retailV,
    "CDE6530board": cde6530board,
    "CDE6530campus": cde6530campus,
    "CDE6530campusV": cde6530campusV,
    "CDE6530crop": cde6530crop,
    "CDE6530cropV": cde6530cropV,
    "CDE6530retail": cde6530retail,
    "CDE6530retailV": cde6530retailV,
    "CDE7530board": cde7530board,
    "CDE7530campus": cde7530campus,
    "CDE7530campusV": cde7530campusV,
    "CDE7530crop": cde7530crop,
    "CDE7530cropV": cde7530cropV,
    "CDE7530retail": cde7530retail,
    "CDE7530retailV": cde7530retailV,
    "CDE8630board": cde8630board,
    "CDE8630campus": cde8630campus,
    "CDE8630campusV": cde8630campusV,
    "CDE8630crop": cde8630crop,
    "CDE8630cropV": cde8630cropV,
    "CDE8630retail": cde8630retail,
    "CDE8630retailV": cde8630retailV,
    "CDE9830board": cde9830board,
    "CDE9830campus": cde9830campus,
    "CDE9830campusV": cde9830campusV,
    "CDE9830crop": cde9830crop,
    "CDE9830cropV": cde9830cropV,
    "CDE9830retail": cde9830retail,
    "CDE9830retailV": cde9830retailV,
    "CDE92UWboard": cde92uwboard,
    "CDE92UWcampus": cde92uwcampus,
    "CDE92UWcampusV": cde92uwcampusV,
    "CDE92UWcrop": cde92uwcrop,
    "CDE92UWcropV": cde92uwcropV,
    "CDE92UWretail": cde92uwretail,
    "CDE92UWretailV": cde92uwretailV,
    "CDE4314-2Cboard": cde43142cBoard,
    "CDE4314-2Ccampus": cde43142cCampus,
    "CDE4314-2CcampusV": cde43142cCampusV,
    "CDE4314-2Ccrop": cde43142cCrop,
    "CDE4314-2CcropV": cde43142cCropV,
    "CDE4314-2Cretail": cde43142cRetail,
    "CDE4314-2CretailV": cde43142cRetailV,
    "CDE5014-2Cboard": cde50142cBoard,
    "CDE5014-2Ccampus": cde50142cCampus,
    "CDE5014-2CcampusV": cde50142cCampusV,
    "CDE5014-2Ccrop": cde50142cCrop,
    "CDE5014-2CcropV": cde50142cCropV,
    "CDE5014-2Cretail": cde50142cRetail,
    "CDE5014-2CretailV": cde50142cRetailV,
    "CDE5514-2Cboard": cde55142cBoard,
    "CDE5514-2Ccampus": cde55142cCampus,
    "CDE5514-2CcampusV": cde55142cCampusV,
    "CDE5514-2Ccrop": cde55142cCrop,
    "CDE5514-2CcropV": cde55142cCropV,
    "CDE5514-2Cretail": cde55142cRetail,
    "CDE5514-2CretailV": cde55142cRetailV,
    "CDE6514-2Cboard": cde65142cBoard,
    "CDE6514-2Ccampus": cde65142cCampus,
    "CDE6514-2CcampusV": cde65142cCampusV,
    "CDE6514-2Ccrop": cde65142cCrop,
    "CDE6514-2CcropV": cde65142cCropV,
    "CDE6514-2Cretail": cde65142cRetail,
    "CDE6514-2CretailV": cde65142cRetailV,
    "CDE7514-2Cboard": cde75142cBoard,
    "CDE7514-2Ccampus": cde75142cCampus,
    "CDE7514-2CcampusV": cde75142cCampusV,
    "CDE7514-2Ccrop": cde75142cCrop,
    "CDE7514-2CcropV": cde75142cCropV,
    "CDE7514-2Cretail": cde75142cRetail,
    "CDE7514-2CretailV": cde75142cRetailV,
    "CDE8614-2Cboard": cde86142cBoard,
    "CDE8614-2Ccampus": cde86142cCampus,
    "CDE8614-2CcampusV": cde86142cCampusV,
    "CDE8614-2Ccrop": cde86142cCrop,
    "CDE8614-2CcropV": cde86142cCropV,
    "CDE8614-2Cretail": cde86142cRetail,
    "CDE8614-2CretailV": cde86142cRetailV,
    "CDE4314-2C": cde43142cCrop,
    "CDE4314-2CV": cde43142cCropV,
    "CDE5014-2C": cde50142cCrop,
    "CDE5014-2CV": cde50142cCropV,
    "CDE5514-2C": cde55142cCrop,
    "CDE5514-2CV": cde55142cCropV,
    "CDE6514-2C": cde65142cCrop,
    "CDE6514-2CV": cde65142cCropV,
    "CDE7514-2C": cde75142cCrop,
    "CDE7514-2CV": cde75142cCropV,
    "CDE8614-2C": cde86142cCrop,
    "CDE8614-2CV": cde86142cCropV,
    "CDE4331-1Cboard": cde4331Board,
    "CDE4331-1Ccampus": cde4331Campus,
    "CDE4331-1CcampusV": cde4331CampusV,
    "CDE4331-1Ccrop": cde4331Crop,
    "CDE4331-1CcropV": cde4331CropV,
    "CDE4331-1Cretail": cde4331Retail,
    "CDE4331-1CretailV": cde4331RetailV,
    "CDE5531-1Cboard": cde5531Board,
    "CDE5531-1Ccampus": cde5531Campus,
    "CDE5531-1CcampusV": cde5531CampusV,
    "CDE5531-1Ccrop": cde5531Crop,
    "CDE5531-1CcropV": cde5531CropV,
    "CDE5531-1Cretail": cde5531Retail,
    "CDE5531-1CretailV": cde5531RetailV,
    "CDE6531-1Cboard": cde6531Board,
    "CDE6531-1Ccampus": cde6531Campus,
    "CDE6531-1CcampusV": cde6531CampusV,
    "CDE6531-1Ccrop": cde6531Crop,
    "CDE6531-1CcropV": cde6531CropV,
    "CDE6531-1Cretail": cde6531H,
    "CDE6531-1CretailV": cde6531RetailV,
    "CDE7531-1Cboard": cde7531Board,
    "CDE7531-1Ccampus": cde7531Campus,
    "CDE7531-1CcampusV": cde7531CampusV,
    "CDE7531-1Ccrop": cde7531Crop,
    "CDE7531-1CcropV": cde7531CropV,
    "CDE7531-1Cretail": cde7531Retail,
    "CDE7531-1CretailV": cde7531RetailV,
    "CDE8631-1Cboard": cde8631Board,
    "CDE8631-1Ccampus": cde8631Campus,
    "CDE8631-1CcampusV": cde8631CampusV,
    "CDE8631-1Ccrop": cde8631Crop,
    "CDE8631-1CcropV": cde8631CropV,
    "CDE8631-1Cretail": cde8631Retail,
    "CDE8631-1CretailV": cde8631RetailV,
    "CDE9831-1Cboard": cde9831Board,
    "CDE9831-1Ccampus": cde9831H,
    "CDE9831-1CcampusV": cde9831CampusV,
    "CDE9831-1Ccrop": cde9831Crop,
    "CDE9831-1CcropV": cde9831CropV,
    "CDE9831-1Cretail": cde9831Retail,
    "CDE9831-1CretailV": cde9831RetailV,
    "CDE4331-1C": cde4331Crop,
    "CDE4331-1CV": cde4331CropV,
    "CDE5531-1C": cde5531Crop,
    "CDE5531-1CV": cde5531CropV,
    "CDE6531-1C": cde6531Crop,
    "CDE6531-1CV": cde6531CropV,
    "CDE7531-1C": cde7531Crop,
    "CDE7531-1CV": cde7531CropV,
    "CDE8631-1C": cde8631Crop,
    "CDE8631-1CV": cde8631CropV,
    "CDE9831-1C": cde9831Crop,
    "CDE9831-1CV": cde9831CropV,
    "CDE43G3-1Cboard": cde43g3Board,
    "CDE43G3-1Ccampus": cde43g3Campus,
    "CDE43G3-1CcampusV": cde43g3CampusV,
    "CDE43G3-1Ccrop": cde43g3Crop,
    "CDE43G3-1CcropV": cde43g3CropV,
    "CDE43G3-1Cretail": cde43g3Retail,
    "CDE43G3-1CretailV": cde43g3RetailV,
    "CDE55G3-1Cboard": cde55g3Board,
    "CDE55G3-1Ccampus": cde55g3Campus,
    "CDE55G3-1CcampusV": cde55g3CampusV,
    "CDE55G3-1Ccrop": cde55g3Crop,
    "CDE55G3-1CcropV": cde55g3CropV,
    "CDE55G3-1Cretail": cde55g3Retail,
    "CDE55G3-1CretailV": cde55g3RetailV,
    "CDE65G3-1Cboard": cde65g3Board,
    "CDE65G3-1Ccampus": cde65g3Campus,
    "CDE65G3-1CcampusV": cde65g3CampusV,
    "CDE65G3-1Ccrop": cde65g3Crop,
    "CDE65G3-1CcropV": cde65g3CropV,
    "CDE65G3-1Cretail": cde65g3Retail,
    "CDE65G3-1CretailV": cde65g3RetailV,
    "CDE75G3-1Cboard": cde75g3Board,
    "CDE75G3-1Ccampus": cde75g3Campus,
    "CDE75G3-1CcampusV": cde75g3CampusV,
    "CDE75G3-1Ccrop": cde75g3Crop,
    "CDE75G3-1CcropV": cde75g3CropV,
    "CDE75G3-1Cretail": cde75g3Retail,
    "CDE75G3-1CretailV": cde75g3RetailV,
    "CDE86G3-1Cboard": cde86g3Board,
    "CDE86G3-1Ccampus": cde86g3Campus,
    "CDE86G3-1CcampusV": cde86g3CampusV,
    "CDE86G3-1Ccrop": cde86g3Crop,
    "CDE86G3-1CcropV": cde86g3CropV,
    "CDE86G3-1Cretail": cde86g3Retail,
    "CDE86G3-1CretailV": cde86g3RetailV,
    "CDE98G3-1Cboard": cde98g3Board,
    "CDE98G3-1Ccampus": cde98g3Campus,
    "CDE98G3-1CcampusV": cde98g3CampusV,
    "CDE98G3-1Ccrop": cde98g3Crop,
    "CDE98G3-1CcropV": cde98g3CropV,
    "CDE98G3-1Cretail": cde98g3Retail,
    "CDE98G3-1CretailV": cde98g3RetailV,
    "CDE43G3-1C": cde43g3Crop,
    "CDE43G3-1CV": cde43g3CropV,
    "CDE55G3-1C": cde55g3Crop,
    "CDE55G3-1CV": cde55g3CropV,
    "CDE65G3-1C": cde65g3Crop,
    "CDE65G3-1CV": cde65g3CropV,
    "CDE75G3-1C": cde75g3Crop,
    "CDE75G3-1CV": cde75g3CropV,
    "CDE86G3-1C": cde86g3Crop,
    "CDE86G3-1CV": cde86g3CropV,
    "CDE98G3-1C": cde98g3Crop,
    "CDE98G3-1CV": cde98g3CropV,
    "LDE108-123crop": lde108123,
    "LDE136G-152crop": lde136g152,
    "LDE163G-182crop": lde163g182,
    "ldm136-151crop": ldm135,
    "ldm163-182crop": ldm163,
    "ldm231-251crop": ldm231,
    "LDC027-120crop": ldc027120,
    "LDC027-120cropV": ldc027120,
    "LDC027-120campus": ldc027120,
    "LDC027-120campusV": ldc027120,
    "LDC027-150crop": ldc027150,
    "LDC027-150cropV": ldc027150,
    "LDC027-150campus": ldc027150,
    "LDC027-150campusV": ldc027150,
    "LDC027-180crop": ldc027180,
    "LDC027-180cropV": ldc027180,
    "LDC027-180campus": ldc027180,
    "LDC027-180campusV": ldc027180,
    "LDC027G-091Ccrop": ldc027g091c,
    "LDC027G-091CcropV": ldc027g091c,
    "LDC027G-091Ccampus": ldc027g091c,
    "LDC027G-091CcampusV": ldc027g091c,
    "LDC027G-121crop": ldc027g121,
    "LDC027G-121cropV": ldc027g121,
    "LDC027G-121campus": ldc027g121,
    "LDC027G-121campusV": ldc027g121,
    "LDC027G-151crop": ldc027g151,
    "LDC027G-151cropV": ldc027g151,
    "LDC027G-151campus": ldc027g151,
    "LDC027G-151campusV": ldc027g151,
    "LDC027G-181crop": ldc027g181,
    "LDC027G-181cropV": ldc027g181,
    "LDC027G-181campus": ldc027g181,
    "LDC027G-181campusV": ldc027g181,
    "LDP136-071Ccrop": ldp136071c,
    "LDP163-091Ccrop": ldp163091c,
    "LDP217-121Ccrop": ldp217121c,
    "LDP217-121C": ldp217121c,
    "LDC031-120crop": ldc031120,
    "LDC031-120cropV": ldc031120,
    "LDC031-120campus": ldc031120,
    "LDC031-120campusV": ldc031120,
    "LDC031-150crop": ldc031150,
    "LDC031-150cropV": ldc031150,
    "LDC031-150campus": ldc031150,
    "LDC031-150campusV": ldc031150,
    "LDC031-180crop": ldc031180,
    "LDC031-180cropV": ldc031180,
    "LDC031-180campus": ldc031180,
    "LDC031-180campusV": ldc031180,
    "LDC031-250crop": ldc031250,
    "LDC031-250cropV": ldc031250,
    "LDC031-250campus": ldc031250,
    "LDC031-250campusV": ldc031250,
    "LDC031G-121crop": ldc031g121,
    "LDC031G-121cropV": ldc031g121,
    "LDC031G-121campus": ldc031g121,
    "LDC031G-121campusV": ldc031g121,
    "LDC031G-151crop": ldc031g151,
    "LDC031G-151cropV": ldc031g151,
    "LDC031G-151campus": ldc031g151,
    "LDC031G-151campusV": ldc031g151,
    "LDC031G-181crop": ldc031g181,
    "LDC031G-181cropV": ldc031g181,
    "LDC031G-181campus": ldc031g181,
    "LDC031G-181campusV": ldc031g181,
    "LDC031G-251crop": ldc031g251,
    "LDC031G-251cropV": ldc031g251,
    "LDC031G-251campus": ldc031g251,
    "LDC031G-251campusV": ldc031g251,
};

export default models
